// extracted by mini-css-extract-plugin
export default {"noRecords":"ContactHistory_noRecords__rGmgu","recordingLink":"ContactHistory_recordingLink__H4v81"};